import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const Icon = ({ type, className, ...other }) => {
  const cns = cn('icon', `icon-${type}`, className);
  // verify that icon is valid in development
  /*
  if (process.env.NODE_ENV !== 'production') {
    const icons = require('./icons.auto.json');
    if (icons.indexOf(type) === -1) {
      // eslint-disable-next-line no-console
      console.warn(
        `icon type=${type} doesn't exist in the icon font, available types: ${icons}`
      );
    }
  }
  */
  return <span className={cns} {...other} />;
};

Icon.propTypes = {
  /**
   * Additional classname
   */
  className: PropTypes.string,
  /**
   * The type of icon
   */
  type: PropTypes.string.isRequired
};

export default Icon;



// WEBPACK FOOTER //
// ./src/components/atoms/Icon/Icon.js